// Components
const NotificationComponent = () => import(/* webpackPrefetch: true, webpackChunkName: 'notification-component' */ '@/app/views/main-view/_shared/_components/notification-component/notification-component.vue');

export default {
	name: 'AdminNotificationContainer',
	components: {
		NotificationComponent
	}
}